module.exports = __webpack_public_path__ + "static/media/kv-en.83243eee.jpg";